'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
var settings = require('./settings-9ee2f03f.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n"], ["\n  background-color: ", ";\n  color: ", ";\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  border-radius: 0px;\n  background-color: ", ";\n  color: ", ";\n"], ["\n  border-radius: 0px;\n  background-color: ", ";\n  color: ", ";\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  @media (max-width: 767px) {\n    line-height: 1.7;\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n  @media (max-width: 767px) {\n    line-height: 1.7;\n  }\n"]),
    _templateObject4 = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  padding: ", ";\n  align-items: center;\n  border-radius: 5px;\n  font-size: ", ";\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: ", ";\n  letter-spacing: normal;\n  ", ";\n  ", ";\n  ", ";\n  ", "\n  ", " ", ";\n  margin: ", ";\n"], ["\n  display: flex;\n  padding: ", ";\n  align-items: center;\n  border-radius: 5px;\n  font-size: ", ";\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: ", ";\n  letter-spacing: normal;\n  ", ";\n  ", ";\n  ", ";\n  ", "\n  ", " ", ";\n  margin: ", ";\n"]);

var errorPanel = styled.css(_templateObject, settings.COLOR.lightSoftRed, settings.COLOR.softRed);

var warningPanel = styled.css(_templateObject, settings.COLOR.pale, settings.COLOR.darkYellow);

var infoPanel = styled.css(_templateObject2, settings.COLOR.lightDeepBlue, settings.COLOR.darkGray);

var infoGrayPanel = styled.css(_templateObject3, settings.COLOR.lineGray, settings.COLOR.superDarkGray);

var Panel = styled__default.div(_templateObject4, function (props) {
  return props.padding ? props.padding : "14px 30px";
}, function (props) {
  return props.fontSize ? props.fontSize : "18px";
}, function (props) {
  return props.lineHeight ? props.lineHeight : "normal";
}, function (props) {
  return props.error && errorPanel;
}, function (props) {
  return props.warning && warningPanel;
}, function (props) {
  return props.info && infoPanel;
}, function (props) {
  return props.infoGray && infoGrayPanel;
}, function (props) {
  return props.sourceSansPro && "font-family: Source Sans Pro, sans-serif;";
}, function (props) {
  return props.height && "height: " + props.height;
}, function (props) {
  return props.margin ? props.margin : "10px 0px";
});

exports.Panel = Panel;
//# sourceMappingURL=panel-styles-275a918b.js.map
